import { useClientContext } from "@hooks/index";
import { useQuery } from "@tanstack/react-query";
import { getMeta } from "./index";

export const useGetGoalsConfig = () => {
  const customFetch = useClientContext();

  return useQuery({
    retry: false,
    queryKey: ["goals"],
    queryFn: getMeta(customFetch),
  });
};
